import userIcon from '../../../assets/image/user.svg';
import invoiceIcon from '../../../assets/image/invoice.svg';
import revenueIcon from '../../../assets/image/revenue.svg';
import calculatorIcon from '../../../assets/image/calculator.svg';
import guideIcon from '../../../assets/image/guide.svg';

export const formatValue = (value, format) => {
	if (!format || value === null || value === undefined) return value;

	switch (format) {
		case 'currency':
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			}).format(value);
		case 'number':
			return new Intl.NumberFormat('en-US').format(value);
		case 'percent':
			return `${(parseFloat(value) * 100).toFixed(1)}%`;
		default:
			return value;
	}
};

export const getIcon = (iconName) => {
	switch (iconName?.toLowerCase()) {
		case 'user':
			return userIcon;
		case 'invoice':
			return invoiceIcon;
		case 'revenue':
			return revenueIcon;
		case 'calculator':
			return calculatorIcon;
		case 'orders':
			return invoiceIcon;
		case 'guide':
			return guideIcon;
		default:
			return invoiceIcon;
	}
};

export function formatTimeAgo(dateString) {
	const date = new Date(dateString);
	const now = new Date();
	const diffMs = now - date;

	const diffMinutes = Math.floor(diffMs / 60000);
	const diffHours = Math.floor(diffMinutes / 60);
	const diffDays = Math.floor(diffHours / 24);
	const diffWeeks = Math.floor(diffDays / 7);

	if (diffMinutes < 1) return 'Just now';
	if (diffMinutes < 60) return `${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`;
	if (diffHours < 24) return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
	if (diffDays === 1) return 'Yesterday';
	if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
	if (diffWeeks === 1) return 'Last week';
	return `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
}

export const getStatusColor = (status) => {
	switch (status?.toLowerCase()) {
		case 'open':
			return '#AEE3FF';
		case 'unpaid':
			return '#FCCFCF';
		case 'partially paid':
			return '#FFEDED';
		case 'partially billed':
			return '#2E63F6';
		case 'billed':
			return '#68C230';
		case 'paid':
			return '#9FD8C2';
		case 'approved':
			return '#D1EEE2';
		case 'received':
			return '#DDE2E5';
		case 'pending':
			return '#DBE9FA';
		case 'overdue':
			return '#D7D7FF';
		case 'cancelled':
			return '#FCE3DF';
		case 'issued':
			return '#F6ECD0';
		case 'delivered':
			return '#DDE2E5';
		case 'credit':
			return '#DBE9FA';
		case 'debit':
			return '#DBE9FA';
		case 'void':
			return '#CFCFCF';
		case 'write off':
			return '#FFEED5';
		default:
			return '#DBE9FA';
	}
};
